







import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';

type Data = {
	ZAZNAM_ID: number;
	TEXT: string;
	ND_NR: string;
	X_CENA_DPH: number;
	VYROBEKND_OZN: string;
};

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'ND_NR' },
		showLabel: { type: Boolean, default: true },
		ndnr: { validator: (prop) => typeof prop === 'string' || prop === null, required: true },
		inputDisabled: { type: Boolean, default: undefined },
	},
	data() {
		return {
			storeObject: NAME,
			emptyObject: {
				value: null,
				text: null,
				ndnr: null,
				cenasdph: null,
				vydejmjid: null,
				vyrobekndozn: null,
			},
		};
	},
	computed: {
		ndNrCmp: {
			get() {
				return this.ndnr;
			},
			set(val) {
				this.$emit('update:ndnr', val);
			},
		},
		inputDisabledCmp() {
			return this.isDisabled || this.inputDisabled;
		},
	},
	methods: {
		focusInput() {
			(this.$refs.input as HTMLFormElement).focus();
		},
		dbToBaseMapper(data: Data) {
			return {
				value: data.ZAZNAM_ID,
				text: data.TEXT,
				ndnr: data.ND_NR,
				cenasdph: data.X_CENA_DPH,
				vydejmjid: null,
				vyrobekndozn: data.VYROBEKND_OZN,
			};
		},
	},
});
